import { COMMUNITY_KIND, COMMUNITY_SOURCE, COMMUNITY_TAB } from '@/types';

const LEGACY_CAMINO_TAB = 'camino';

const COMMUNITY_TAB_VALUES = new Set<string>(Object.values(COMMUNITY_TAB));

export const DEFAULT_COMMUNITY_TAB = COMMUNITY_TAB.BUSINESS;

export type CommunityTabDefinition = {
  value: COMMUNITY_TAB;
  kind: COMMUNITY_KIND;
  source: COMMUNITY_SOURCE;
  labelKey: string;
  listsTitleKey: string;
  virtualAllLabelKey: string;
  showCaminoIcon: boolean;
};

export const COMMUNITY_TAB_DEFINITIONS: CommunityTabDefinition[] = [
  {
    value: COMMUNITY_TAB.BUSINESS,
    kind: COMMUNITY_KIND.BUSINESS,
    source: COMMUNITY_SOURCE.MANUAL,
    labelKey: 'community.tabs.businessList',
    listsTitleKey: 'community.tabs.businessList',
    virtualAllLabelKey: 'community.lists.allBusiness',
    showCaminoIcon: false,
  },
  {
    value: COMMUNITY_TAB.FAMILY,
    kind: COMMUNITY_KIND.FAMILY,
    source: COMMUNITY_SOURCE.MANUAL,
    labelKey: 'community.tabs.familyList',
    listsTitleKey: 'community.tabs.familyList',
    virtualAllLabelKey: 'community.lists.allFamily',
    showCaminoIcon: false,
  },
  {
    value: COMMUNITY_TAB.CAMINO_BUSINESS,
    kind: COMMUNITY_KIND.BUSINESS,
    source: COMMUNITY_SOURCE.CAMINO,
    labelKey: 'community.tabs.caminoBusinessList',
    listsTitleKey: 'community.lists.caminoBusinessListTitle',
    virtualAllLabelKey: 'community.lists.allCaminoBusiness',
    showCaminoIcon: true,
  },
  {
    value: COMMUNITY_TAB.CAMINO_FAMILY,
    kind: COMMUNITY_KIND.FAMILY,
    source: COMMUNITY_SOURCE.CAMINO,
    labelKey: 'community.tabs.caminoFamilyList',
    listsTitleKey: 'community.lists.caminoFamilyListTitle',
    virtualAllLabelKey: 'community.lists.allCaminoFamily',
    showCaminoIcon: true,
  },
  {
    value: COMMUNITY_TAB.MEMBER,
    kind: COMMUNITY_KIND.MEMBER,
    source: COMMUNITY_SOURCE.CAMINO,
    labelKey: 'community.tabs.caminoMemberList',
    listsTitleKey: 'community.lists.caminoMemberListTitle',
    virtualAllLabelKey: 'community.lists.allCaminoMember',
    showCaminoIcon: true,
  },
];

const COMMUNITY_TAB_DEFINITION_BY_VALUE: Record<COMMUNITY_TAB, CommunityTabDefinition> =
  COMMUNITY_TAB_DEFINITIONS.reduce(
    (acc, definition) => {
      acc[definition.value] = definition;
      return acc;
    },
    {} as Record<COMMUNITY_TAB, CommunityTabDefinition>
  );

type CommunityTabParams = {
  tab: string | undefined;
};

export const isCommunityTab = (params: CommunityTabParams): params is { tab: COMMUNITY_TAB } => {
  return Boolean(params.tab) && COMMUNITY_TAB_VALUES.has(params.tab as string);
};

export const resolveCommunityTab = (params: CommunityTabParams): COMMUNITY_TAB => {
  if (params.tab === LEGACY_CAMINO_TAB) {
    return COMMUNITY_TAB.MEMBER;
  }

  if (isCommunityTab(params)) {
    return params.tab;
  }

  return DEFAULT_COMMUNITY_TAB;
};

export const getCommunityTabDefinition = ({ tab }: { tab: COMMUNITY_TAB }): CommunityTabDefinition => {
  return COMMUNITY_TAB_DEFINITION_BY_VALUE[tab];
};

type ResolveCommunityTabFromKindSourceParams = {
  kind: COMMUNITY_KIND;
  source?: COMMUNITY_SOURCE | null;
};

export const resolveCommunityTabFromKindSource = ({
  kind,
  source,
}: ResolveCommunityTabFromKindSourceParams): COMMUNITY_TAB => {
  if (kind === COMMUNITY_KIND.MEMBER) {
    return COMMUNITY_TAB.MEMBER;
  }

  if (source === COMMUNITY_SOURCE.CAMINO) {
    if (kind === COMMUNITY_KIND.FAMILY) {
      return COMMUNITY_TAB.CAMINO_FAMILY;
    }

    return COMMUNITY_TAB.CAMINO_BUSINESS;
  }

  if (kind === COMMUNITY_KIND.FAMILY) {
    return COMMUNITY_TAB.FAMILY;
  }

  return COMMUNITY_TAB.BUSINESS;
};
